import onboarding from 'assets/images/onboarding.png'
import SessionConst from 'constants/SessionConst'
import React, { Component } from 'react'
import * as XLSX from 'xlsx'
import * as FileSaver from 'file-saver'
import { IconContext } from "react-icons"
import {FaExclamationCircle, FaFileExcel, FaLock, FaLockOpen} from 'react-icons/fa'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isArrayNotEmpty, removeHotelInfoFromSession, removeHotelOnboardingStatusFromSession,
    removeLockStatusFromSession, searchObjectList } from 'utilities/JSUtil'
import * as FormConst from '../../constants/FormConst'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import HotelInfoService from '../../services/HotelInfoService'
import { getSessionItem } from '../../utilities/SessionHelper'
import Button from '../atoms/Button/Button'
import FormModal from '../organisms/FormModal/FormModal'
import Pagination from '../organisms/Pagination/Pagination'
import './AdminHotelList.scss'

class AdminHotelList extends Component {

    statusList = Object.keys(FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS)
    displayStatusList = Object.keys(FormConst.HOTEL_ONBOARDING_DISPLAY_STATUS_TO_STATUS)

    constructor(props) {
        super(props)
        this.state = {
            sessionData: null,
            hotelCode: '',
            status: this.statusList,
            onboardingHotelsList: [],
            filteredOnboardingHotelsList: [],
            searchKeyHotelCode: '',
            searchKeyOnboardingStatus: '',
            errorMessage: undefined,
            currentUser: getSessionItem(SessionConst.USER).username,
            isLoading: true,
            isDownloading: false,
            isUpdateLock: false,
            editIndex: -1,
            limit: 50,
            total: 0,
            user: getSessionItem(SessionConst.USER)
        }

        this.searchOnboardingApplicationsWithFilter = this.searchOnboardingApplicationsWithFilter.bind(this)
    }

    async componentDidMount() {
        removeHotelInfoFromSession()
        removeLockStatusFromSession()
        removeHotelOnboardingStatusFromSession()
        await HotelInfoService.searchOnboardingApplicationsByStatus(this.state.status, 0, this.state.limit)
            .then(onboardingResponse => {

            HotelInfoService.searchOnboardingApplicationsByStatus(this.state.status, 0, onboardingResponse.metaData.total)
            .then(onboardingResponseAllHotels => {
                const hotelsList = onboardingResponseAllHotels.hotelOnboardingDetailsList.map((entry, index) => {
                    return {
                        index: index,
                        ...entry
                    }
                })

                const slicedHotelsList = hotelsList.slice(0,this.state.limit)

                if (isArrayNotEmpty(onboardingResponseAllHotels.hotelOnboardingDetailsList)) {
                    this.setState({ 
                        onboardingHotelsList: slicedHotelsList,
                        filteredOnboardingHotelsList: slicedHotelsList,
                        isLoading: false, 
                        errorMessage: undefined,
                        total: onboardingResponseAllHotels.metaData.total,
                        onboardingHotelsListAll: hotelsList
                    })

                } else {
                    this.setState({ errorMessage: 'No onboarding details found', isLoading: false })
                }
            })
            }).catch(error => {
                this.setState({ errorMessage: 'No onboarding details found', isLoading: false })
            })
    }

    searchOnboardingApplicationsWithFilter = async (offset, limit = this.state.limit) => {
        this.setState({isLoading: true})

        let hotelsList  = this.state.onboardingHotelsListAll

        if(this.state.filtered) {
            hotelsList = this.state.filteredOnboardingHotelsListNew
        }
        const maxLimit = offset+limit
        const slicedHotelList = hotelsList.slice(offset,maxLimit)

        if (isArrayNotEmpty(slicedHotelList)) {
            this.setState({
                onboardingHotelsList: slicedHotelList,
                filteredOnboardingHotelsList: slicedHotelList,
                isLoading: false,
                errorMessage: undefined,
                total: hotelsList.length,
            })

        } else {
            this.setState({ errorMessage: 'No onboarding details found', isLoading: false })
        }
    }

    redirectToUpdateOnboarding = (onboardingEntry, action) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_UPDATE_ONBOARDING_PAGE,
            state: {
                hotelCode: onboardingEntry.hotelCode,
                onboardingStatus: onboardingEntry,
                action: action
            }
        })
    }

    redirectToLaunchOnboardingApplication = (onboardingEntry) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE,
            state: {
                hotelCode: onboardingEntry.hotelCode,
                onboardingStatus: onboardingEntry,
                action: onboardingEntry.status === FormConst.STATUS_READY_FOR_REVIEW
            }
        })
    }

    redirectToSearch = () => {
        this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    handleErrorModalCancel = () => {
        this.setState({ errorMessage: undefined })
    }

    acquireLock = async (hotelCode) => {
        // Call HDMS to acquire lock
        this.props.acquireUser(hotelCode)
        this.setState({ editIndex: hotelCode, isUpdateLock: true, errorMessage: undefined })
    }

    generateExcel = async (status, limit) => {
        this.setState({isDownloading:true, downloadProgress:FormConst.MODAL_DOWNLOAD_ACTION_TEXT})
        let hotelInfoData = [['Hotel Code', 'Status', 'Brand Code', 'Brand Name', '% Complete', 'Red Flag']]
        let offset = 0
        let percentage = 0
        const limitPerCall = 100
        const iterations = limit <= limitPerCall ? 1 : (limit / limitPerCall)
        // split into calls of 100 records per call so API can process all records
        for(let i=0; i<iterations; i++) {
            const progressMessage = "\n\nProgress: "+percentage+"%"
            this.setState({downloadProgress: FormConst.MODAL_DOWNLOAD_ACTION_TEXT+progressMessage})
            const data = {
                status : this.state.searchKeyOnboardingStatus !== '' ? this.state.searchKeyOnboardingStatus :  status,
                offset: offset,
                limit : limitPerCall
            }
            offset += limitPerCall
            percentage = Number((offset/limit)*100).toFixed(2)

            /* generate an array of arrays containing the hotelInfoData */
            await HotelInfoService.getBasicHotelInfoWithBrandAndName(data).then(async (response) => {
                response.hotelOnboardingDetailsList.map( hotelInfo => {
                    const progress = this.calculateProgress(hotelInfo.checklist);
                    const rowData = [hotelInfo.hotelCode, hotelInfo.status, hotelInfo.brand, hotelInfo.brandName, progress + ' %', hotelInfo.stateInError ? 'Yes' : 'No']
                    hotelInfoData.push(rowData)
                })
            }).catch(error => {
                this.setState({
                                  isDownloading: false,
                                  showErrorModal: true,
                                  errorMessage: 'There was an error while retrieving excel data'
                              })
                i = iterations
            })

        }

        this.setState({isDownloading:false})

        // Only download the file when excel data has no errors
        if(!this.state.showErrorModal) {
            /* convert the hotelInfoData to a worksheet */
            const worksheet = XLSX.utils.aoa_to_sheet(hotelInfoData)

            /* get the worksheet as a string */
            const workBook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workBook, worksheet, 'Sheet1')
            const workBookOutput = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' })

            /* trigger a download of the excel file */
            FileSaver.saveAs(new Blob([workBookOutput], { type: 'application/octet-stream' }), 'existing-onboardings.xlsx')
        }

    }

    calculateProgress(checklist) {
        let progress = 0
        if (isArrayNotEmpty(checklist)) {
            // calculate progress
            let totalCount = checklist.length
            let completedCount = searchObjectList('processedFlag', 'COMPLETED', checklist).length
            progress = Math.floor(100 * completedCount / totalCount)
        }
        return progress;
    }

    resetLock = (hotelCode) => {
        // Call HDMS to reset lock
        this.props.resetUser(hotelCode)
        this.setState({ editIndex: hotelCode, isUpdateLock: true, errorMessage: undefined })
    }

    searchOptions = (hotelCode, status, onboardingHotelsList) => {

        const hotelsListOriginal = this.state.onboardingHotelsListAll

        let filteredList
        // If status filter is present, first filter using the status
        if(status && hotelCode){
            filteredList = hotelsListOriginal.filter(option => option.status === status)
            filteredList = filteredList.filter(option => option.hotelCode.startsWith(hotelCode))
            this.setState({
                filteredOnboardingHotelsList: filteredList,
                total: filteredList.length,
                filteredOnboardingHotelsListNew: filteredList,
                filtered: true,
            })
        } else if (status) {
            filteredList = hotelsListOriginal.filter(option => option.status === status)
            this.setState({
                filteredOnboardingHotelsList: filteredList,
                total: filteredList.length,
                filteredOnboardingHotelsListNew: filteredList,
                filtered: true,
            })
        } else if (hotelCode) {
            filteredList = hotelsListOriginal.filter(option => option.hotelCode.startsWith(hotelCode))
            const filteredListFinal = filteredList.slice(0, 50)
            this.setState({
                filteredOnboardingHotelsList: filteredListFinal,
                total: filteredList.length,
                filteredOnboardingHotelsListNew: filteredList,
                filtered: true,
            })
        } else {
            this.refreshPage();
        }

        this.setState({
            searchKeyHotelCode: hotelCode,
            searchKeyOnboardingStatus: status,
        })
    }

    refreshPage = () => {
      window.location.reload();
    }

    handleAction = (onboardingEntry) => {
        switch (onboardingEntry.status) {
            case FormConst.STATUS_GENERATED:
                this.redirectToUpdateOnboarding(onboardingEntry, FormConst.ACTION_START_APPLICATION)
                break
            case FormConst.STATUS_READY_FOR_REVIEW:
                this.redirectToUpdateOnboarding(onboardingEntry, FormConst.ACTION_START_REVIEW)
                break
            default: this.redirectToLaunchOnboardingApplication(onboardingEntry)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.ACQUIRE_USER) {
                // This means we searched for onboarding status
                if (this.props.errorMessage) {
                    this.setState({
                        errorMessage: 'Could not acquire lock',
                        isUpdateLock: false
                    })
                } else {
                    let onboardingHotelsListALLHotels = this.state.onboardingHotelsListAll;

                    if(this.state.filtered) {
                        onboardingHotelsListALLHotels = this.state.filteredOnboardingHotelsListNew
                    }
                    this.state.searchKeyHotelCode = this.state.editIndex
                    let updatedRecord = onboardingHotelsListALLHotels.find(item => item.hotelCode === this.state.editIndex);
                    updatedRecord.assignedTo = getSessionItem(SessionConst.USER).username

                    const index = onboardingHotelsListALLHotels.findIndex(item => item.hotelCode === this.state.editIndex)
                    onboardingHotelsListALLHotels[index] = updatedRecord
                    let onboardingHotelsList = onboardingHotelsListALLHotels;
                    this.setState({
                        onboardingHotelsList: onboardingHotelsList,
                        filteredList: this.searchOptions(this.state.searchKeyHotelCode, this.state.searchKeyOnboardingStatus, onboardingHotelsList),
                        isUpdateLock: false
                    })
                }
            } else if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.RESET_USER) {
                // This means we searched for onboarding status
                if (this.props.errorMessage) {
                    this.setState({
                        errorMessage: 'Could not reset lock',
                        isUpdateLock: false
                    })
                } else {
                    let onboardingHotelsListALLHotels = this.state.onboardingHotelsListAll;

                    if(this.state.filtered) {
                        onboardingHotelsListALLHotels = this.state.filteredOnboardingHotelsListNew
                    }
                    this.state.searchKeyHotelCode = this.state.editIndex
                    let updatedRecord = onboardingHotelsListALLHotels.find(item => item.hotelCode === this.state.editIndex);
                    updatedRecord.assignedTo = ''

                    const index = onboardingHotelsListALLHotels.findIndex(item => item.hotelCode === this.state.editIndex)
                    onboardingHotelsListALLHotels[index] = updatedRecord
                    let onboardingHotelsList = onboardingHotelsListALLHotels;

                    this.setState({
                        onboardingHotelsList: onboardingHotelsList,
                        filteredList: this.searchOptions(this.state.searchKeyHotelCode, this.state.searchKeyOnboardingStatus, onboardingHotelsList),
                        isUpdateLock: false,
                        editIndex: -1
                    })
                }
            }
        }
    }

    render() {
        return (
            <div className='admin-hotel-list-page'>
                <img id='admin-page-logo' src={onboarding} className='onboarding-img' />
                <div className='admin-hotel-list'>
                    <Button
                        id='admin-page-search-page-button-top'
                        name='Go to search page'
                        className='search-button'
                        onClick={this.redirectToSearch} />

                    <p id='admin-page-info' className='admin-hotel-list-header'>Existing onboarding applications:</p>
                    {
                        isArrayNotEmpty(this.state.onboardingHotelsList)
                        && <div className='admin-page-filters'>
                            <label id='admin-page-hotel-code-label' htmlFor='searchKeyHotelCode'><b>Search:</b></label>
                            <input id='admin-page-hotel-code-label' type='text' name='searchKeyHotelCode' id='search-key'
                                placeholder='Hotel Code'
                                value={this.state.searchKeyHotelCode}
                                onChange={(e) => {
                                    e.preventDefault()
                                    this.searchOptions(e.target.value.trim().toUpperCase(), this.state.searchKeyOnboardingStatus, this.state.onboardingHotelsList)
                                }
                                } />
                            <br />
                            <br />
                            <label id='admin-page-status-filter-label' htmlFor='searchKeyOnboardingStatus'><b>Filter by status:</b></label>
                            <select id='admin-page-status-filter' name='searchKeyOnboardingStatus' id='filter-key'
                                value={this.state.searchKeyOnboardingStatus}
                                onChange={(e) => {
                                    e.preventDefault()
                                    // values.categoryCode = e.target.value
                                    this.searchOptions(this.state.searchKeyHotelCode, e.target.value, this.state.onboardingHotelsList)
                                }
                                }>
                                <option value=''></option>
                                {
                                    this.displayStatusList.map((status, index) => <option key={index} value={FormConst.HOTEL_ONBOARDING_DISPLAY_STATUS_TO_STATUS[status]}>{status}</option>)
                                }
                            </select>
                            <br/>
                            <br/>

                            <div id="download-excel-button"
                                 className="download-excel-button">
                                <FaFileExcel />
                                <Button
                                    name="Download"
                                    role="link"
                                    overridedisabledflag='true'
                                    onClick={() => this.generateExcel(this.state.status, this.state.total)} />
                            </div>

                        </div>
                    }

                    <table
                        id='admin-page-application-list-table'
                        className='table table-striped admin-hotel-list-table'>
                        <thead>
                            <tr>
                                <th>Hotel Code</th>
                                <th>Status</th>
                                <th className="large-column">Assigned To</th>
                                <th>Brand Code</th>
                                <th className="large-column">Brand Name</th>
                                <th>Progress</th>
                                {!this.state.user.isReadOnlyUser && (
                                    <>
                                        <th>Launch</th>
                                        <th>Lock</th>
                                        <th>Unlock</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.filteredOnboardingHotelsList)
                                    ? (
                                        this.state.filteredOnboardingHotelsList.map((onboardingEntry, index) =>
                                            <tr key={index}>
                                                <td>
                                                    {onboardingEntry.hotelCode}
                                                    {onboardingEntry.stateInError
                                                        ? <IconContext.Provider value={{ className: 'error' }} ><FaExclamationCircle /></IconContext.Provider>
                                                        : <></>}
                                                </td>
                                                <td>{FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingEntry.status]}</td>
                                                <td>{onboardingEntry.assignedTo}</td>
                                                <td>{onboardingEntry.brand}</td>
                                                <td>{onboardingEntry.brandName}</td>
                                                <td>{this.calculateProgress(onboardingEntry.checklist) + ' %'}</td>
                                                {!this.state.user.isReadOnlyUser && (
                                                    <>
                                                <td>
                                                    <Button role='link' name={FormConst.HOTEL_ONBOARDING_STATUS_TO_ACTION[onboardingEntry.status]}
                                                        onClick={() => this.handleAction(onboardingEntry)} />
                                                </td>
                                                <td>
                                                    {
                                                        !FormConst.DISABLE_ACQUIRE_LOCK_STATUS_LIST.includes(onboardingEntry.status)
                                                        && <Button
                                                            role='link'
                                                            name={<FaLock />}
                                                            onClick={() => { this.acquireLock(onboardingEntry.hotelCode) }}
                                                            disabled={onboardingEntry.assignedTo === this.state.currentUser} />
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        !FormConst.DISABLE_ACQUIRE_LOCK_STATUS_LIST.includes(onboardingEntry.status)
                                                        && <Button
                                                            role='link'
                                                            name={<FaLockOpen />}
                                                            onClick={() => { this.resetLock(onboardingEntry.hotelCode) }} />
                                                    }

                                                </td>
                                                    </>
                                                )}
                                            </tr>)
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={9} className='text-center'>There are no existing onboarding applications</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>

                    <Pagination 
                        total={this.state.total}
                        pageLimit={this.state.limit}
                        getData={this.searchOnboardingApplicationsWithFilter} />

                    <Button
                        id='admin-page-search-page-button-bottom'
                        name='Go to search page'
                        className='search-button'
                        onClick={this.redirectToSearch} />
                    <FormModal
                        id='admin-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={<h5>{FormConst.MODAL_READ_ACTION_TEXT}</h5>}
                        show={this.state.isLoading}
                        isLoadingIndicator />
                    <FormModal
                        id='admin-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={this.state.downloadProgress}
                        show={this.state.isDownloading}
                        isLoadingIndicator />
                    <FormModal
                        id='admin-page-update-lock-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={<h5>{FormConst.MODAL_UPDATE_LOCK_TEXT}</h5>}
                        show={this.state.isUpdateLock}
                        isLoadingIndicator />
                    <FormModal
                        id='admin-page-error-modal'
                        title='Error'
                        body={<h5>{this.state.errorMessage}</h5>}
                        isError
                        hotelInfo={this.state.hotelInfo}
                        show={!!this.state.errorMessage}
                        cancel={this.handleErrorModalCancel} />
                </div>
            </div>
        )
    }

}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        lockStatusResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        acquireUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.ACQUIRE_USER, { hotelCode: hotelCode })),
        resetUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.RESET_USER, { hotelCode: hotelCode }))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminHotelList))